import { Outlet, createRootRoute } from "@tanstack/react-router";
import { HeartRateDock } from "@/entities/heart-rate/ui/heart-rate-dock";
import { OfflineBanner } from "@/features/offline-status/ui/offline-banner";
import { PwaUpdateBanner } from "@/features/pwa-update/ui/pwa-update-banner";
import { TooltipProvider } from "@/shared/ui/tooltip";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent(): React.JSX.Element {
  return (
    <TooltipProvider>
      <Outlet />
      <HeartRateDock />
      <OfflineBanner />
      <PwaUpdateBanner />
    </TooltipProvider>
  );
}
